import { IValueViewModel, ObjectType } from '../../models';
import { tagDefaultState } from '../../common';

export type goMethod = (state: string, params: {}) => void;
type popoverCallback = (vm: IValueViewModel, go: goMethod) => () => void;

export const getPopoverCallback: popoverCallback = (vm: IValueViewModel, go: goMethod) => {
    return vm.objectType === ObjectType.Tag
        ? () => go(tagDefaultState, { tagDefinitionGuid: vm.guid })
        : () => go('linked', { linkedGuid: vm.guid });
};